module.exports = __webpack_public_path__ + "static/img/flag.f83a0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/flag.png
// module id = EN8g
// module chunks = 21